import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const MW_NOTIFICATION_DESIGN_ITERATION_TEST_NAME = 'mwNotificationDesignIteration_May2026';
const IMPROVE_PRICE_DROP_OFFER_NOTIFICATIONS_TEST_NAME =
    'improvePriceDropOfferNotifications_May2026';

let mwNotificationDesignIterationTestHasBeenTracked = false;

/**
 * MW-only A/B test. Trigger fires on every MW header load (call from a MW-only
 * component). Returns true when the user is in the `variant` bucket.
 */
export const useMwNotificationDesignIterationVariant = (): boolean | null => {
    const [isVariant, setIsVariant] = useState<boolean | null>(null);

    useEffect(() => {
        const test = getAbTestV2(MW_NOTIFICATION_DESIGN_ITERATION_TEST_NAME);

        if (!test) {
            setIsVariant(false);
            return;
        }

        setIsVariant(test.variant === 'variant');

        if (!mwNotificationDesignIterationTestHasBeenTracked) {
            trackAbTestV2Variant(MW_NOTIFICATION_DESIGN_ITERATION_TEST_NAME);
            mwNotificationDesignIterationTestHasBeenTracked = true;
        }
    }, []);

    return isVariant;
};

export const isMwNotificationDesignIterationVariant = (): boolean => {
    return getAbTestV2(MW_NOTIFICATION_DESIGN_ITERATION_TEST_NAME)?.variant === 'variant';
};

export const isImprovePriceDropOfferNotificationVariant = (): boolean =>
    getAbTestV2(IMPROVE_PRICE_DROP_OFFER_NOTIFICATIONS_TEST_NAME)?.variant === 'variant';

export const trackImprovePriceDropOfferNotificationTest = (): void => {
    trackAbTestV2Variant(IMPROVE_PRICE_DROP_OFFER_NOTIFICATIONS_TEST_NAME);
};
